import style from './InlineAlert.scss';

export const Success = ({ className }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M0 8C0 12.4111 3.58809 16 8 16C12.4119 16 16 12.4119 16 8C16 3.58809 12.4119 0 8 0C3.58809 0 0 3.58809 0 8Z"
      fill="#6FA754"
      className={style.successIcon}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.8114 6.13496L7.32469 10.8049C7.07489 11.065 6.6752 11.065 6.4254 10.8049L4.18735 8.45487C3.93755 8.19471 3.93755 7.77479 4.18735 7.51503C4.43716 7.25487 4.83684 7.25487 5.08665 7.51503L6.88524 9.39513L10.9219 5.19512C11.1717 4.93496 11.5714 4.93496 11.8212 5.19512C12.0612 5.45489 12.0612 5.87481 11.8114 6.13496H11.8114Z"
      fill="white"
    />
  </svg>
);

export const Warning = ({ className }) => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M9.53297 1.00564L15.7573 13.0081C16.4461 14.3751 15.5937 16 14.2244 16H1.77684C0.407463 16 -0.445033 14.3629 0.244967 12.9967L6.46929 1.02922C7.15361 -0.327593 8.8486 -0.350497 9.53297 1.00564Z"
      fill="#F2C602"
      className={style.warningIcon}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 4C7.44772 4 7 4.44772 7 5V10C7 10.5523 7.44772 11 8 11C8.55228 11 9 10.5523 9 10V5C9 4.44772 8.55228 4 8 4ZM8 14C8.55228 14 9 13.5523 9 13C9 12.4477 8.55228 12 8 12C7.44772 12 7 12.4477 7 13C7 13.5523 7.44772 14 8 14Z"
      fill="white"
    />
  </svg>
);

export const Error = ({ className }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16ZM9 4C9 3.44772 8.55228 3 8 3C7.44772 3 7 3.44772 7 4V9C7 9.55228 7.44772 10 8 10C8.55228 10 9 9.55228 9 9V4ZM7 12C7 12.5523 7.44772 13 8 13C8.55228 13 9 12.5523 9 12C9 11.4477 8.55228 11 8 11C7.44772 11 7 11.4477 7 12Z"
      fill="#E84524"
      className={style.errorIcon}
    />
  </svg>
);

export const Info = ({ className }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M2.34301 2.34301C-0.781003 5.46702 -0.781003 10.533 2.34301 13.657C5.46702 16.781 10.533 16.781 13.657 13.657C16.781 10.533 16.781 5.46702 13.657 2.34301C10.533 -0.781003 5.46702 -0.781003 2.34301 2.34301ZM8.32051 3.3562C8.99597 3.3562 9.5362 3.91359 9.5362 4.58905C9.5362 5.26452 8.97881 5.82191 8.32051 5.82191C7.64504 5.82191 7.08765 5.26451 7.08765 4.57257C7.08831 3.89645 7.64504 3.35622 8.32051 3.35622V3.3562ZM10.06 11.6134C10.0263 11.715 9.95841 11.833 9.89112 11.9003C9.4518 12.3561 8.91157 12.6266 8.26975 12.6266C7.96565 12.6266 7.67872 12.6266 7.37462 12.5758C6.88518 12.5085 6.25984 11.9003 6.34427 11.2585C6.41156 10.8192 6.4795 10.3805 6.54678 9.94121C6.682 9.18132 6.81723 8.40427 6.95178 7.64431C6.95178 7.59351 6.96894 7.54272 6.96894 7.49259C6.96894 7.17202 6.86735 7.05327 6.54677 7.01963C6.41155 7.00248 6.27632 6.98599 6.14176 6.95235C5.99005 6.90156 5.90562 6.76633 5.9221 6.64826C5.93925 6.51303 6.02369 6.4286 6.19256 6.39496C6.27699 6.37781 6.37858 6.37781 6.4795 6.37781H7.61076H8.80997C9.09691 6.37781 9.26578 6.51303 9.26578 6.79997C9.26578 7.03611 9.23213 7.27293 9.18134 7.50907C9.02963 8.38704 8.86077 9.24855 8.70838 10.1265C8.65759 10.4134 8.59031 10.7004 8.55667 10.988C8.53952 11.1232 8.55667 11.2749 8.59031 11.4101C8.6411 11.5962 8.77633 11.6971 8.96168 11.6806C9.11339 11.6634 9.26577 11.6133 9.41748 11.5454C9.53555 11.4946 9.63714 11.4101 9.75521 11.3765C9.95903 11.3099 10.1108 11.4279 10.06 11.6133L10.06 11.6134Z"
      fill="#448ABF"
      className={style.infoIcon}
    />
  </svg>
);
